import { render, staticRenderFns } from "./FileQuotaEditDialog.vue?vue&type=template&id=b7e5112c&"
import script from "./FileQuotaEditDialog.vue?vue&type=script&lang=js&"
export * from "./FileQuotaEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports